var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: {
            width: "1080",
            transition: "dialog-top-transition",
            eager: ""
          },
          model: {
            value: _vm.openDialog,
            callback: function($$v) {
              _vm.openDialog = $$v
            },
            expression: "openDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-row",
                { attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c(
                        "v-toolbar",
                        {
                          attrs: {
                            dense: "",
                            color: "purple",
                            dark: "",
                            flat: ""
                          }
                        },
                        [_c("span", [_vm._v("Transaction Form")])]
                      ),
                      _c("create-voucher-transaction", {
                        attrs: {
                          "voucher-id": _vm.voucherId,
                          edit: _vm.voucherChequeEdit
                        },
                        on: {
                          "update:edit": function($event) {
                            _vm.voucherChequeEdit = $event
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "8" } },
                    [
                      _c(
                        "v-toolbar",
                        {
                          attrs: {
                            dense: "",
                            color: "primary",
                            dark: "",
                            flat: ""
                          }
                        },
                        [
                          _c("span", [_vm._v("Transaction List")]),
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "white",
                                text: "",
                                small: "",
                                dense: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$refs.tableChequeNumber.voucherTransactionGetByVoucher()
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("mdi-recycle")])],
                            1
                          )
                        ],
                        1
                      ),
                      _c("table-voucher-transactions", {
                        ref: "tableChequeNumber",
                        attrs: {
                          "voucher-id": _vm.voucherId,
                          "voucher-amount": _vm.voucherAmount
                        },
                        model: {
                          value: _vm.voucherChequeEdit,
                          callback: function($$v) {
                            _vm.voucherChequeEdit = $$v
                          },
                          expression: "voucherChequeEdit"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }